export enum ClientReminderStatus {
    Active = 'Active',
    Completed = 'Completed',
}

export interface ClientReminder {
    id: number;
    status: ClientReminderStatus;
    note: string;
    dateTime?: string;
    isAllDay: boolean;
}

export type CreateClientReminder = Omit<ClientReminder, 'id'>;

export enum TimeOfDay {
    AM = 'AM',
    PM = 'PM',
}
